import React from "react"
import { CircularProgress, alpha, Button } from "@mui/material"
import * as hooks from "lib/hooks"

export interface LoadingButtonProps extends React.ComponentProps<typeof Button> {
	loading?: boolean
	loadingElement?: React.ReactNode
}

export function LoadingButton({
	loading,
	children,
	loadingElement,
	color = "primary",
	variant = "contained",
	...props
}: LoadingButtonProps) {
	const materialColors = hooks.UseMaterialColors()

	// Calculate the appropriate loading color based on variant and theme
	const getLoadingColor = () => {
		if (variant === "contained" && !materialColors.isDark) {
			return materialColors.onPrimary
		}
		return materialColors.primary
	}

	return (
		<Button
			disabled={loading || props.disabled}
			color={color}
			variant={variant}
			{...props}
			
		>
			{/* Show spinner with fade in/out animation when loading */}
			{loading && (
				<CircularProgress
					size={24}
					thickness={4}
					sx={{
						"color": getLoadingColor(),
						"position": "absolute",
						"left": "50%",
						"marginLeft": "-12px",
						"animation": "fadeIn 0.2s forwards",
						"@keyframes fadeIn": {
							"0%": { opacity: 0 },
							"100%": { opacity: 1 },
						},
					}}
				/>
			)}

			{/* Fade out content when loading */}
			<span
				style={{
					opacity: loading ? 0 : 1,
					transition: "opacity 0.2s",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					gap: "8px",
				}}
			>
				{children}
			</span>
		</Button>
	)
}
